import { useNatlCommitteeManagementGate } from "./useNatlCommitteeManagementEnabled";
import { CommitteeManagementPageContent } from "./_components/CommitteeManagementPageContent";
import LegacyCommitteesRedirect from "./_LegacyCommitteesRedirect";

export default function AllCommitteesPage() {
  const { enabled, flagsLoaded } = useNatlCommitteeManagementGate();

  if (!flagsLoaded) {
    return null;
  }

  if (!enabled) {
    return <LegacyCommitteesRedirect />;
  }

  return <CommitteeManagementPageContent activeTab="all" />;
}
